const TMSideMenu = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'tm.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'ri-home-4-line'
  },
  {
    title: 'Sales Order Tracker',
    is_heading: false,
    is_active: false,
    link: {
      name: 'tm.sales-order-tracker'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'ri-map-pin-range-fill'
  }
]

export default TMSideMenu
